import React from 'react';
import {connect} from 'react-redux';
import {loadUsers} from '../../actions/userActions';
import { Button, Collapse} from 'reactstrap';
import {join} from 'lodash';
import ReactTable from 'react-table';
import moment from 'moment';
import {BASE_URL, EMPTY_GUID, ROLE_ClientUser, ROLE_LocationUser} from '../../constants';
import { push } from '../../utils/navigation';
import 'react-table/react-table.css';
import { mustBeArray } from '../../utils/lib';
import { Outlet } from 'react-router-dom';

const dateFormat = 'DD/MM/YYYY';

class UsersPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isResetPassword: false,
      filterActive: [],
      activeFilters: [{value: 'active', label: 'Active'}, {value: 'inactive', label: 'In-Active'}, {value: 'authRequest', label: 'Authorisation Request'}]
    };

    this.newUser = this.newUser.bind(this);
    this.selectUser = this.selectUser.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }

  componentDidMount(){
    this.props.dispatch(loadUsers());
  }

  newUser() {
    this.props.dispatch(push(`${BASE_URL}/manage/users/${EMPTY_GUID}`));
  }

  selectUser(e, userId) {
    e.preventDefault();
    this.props.dispatch(push(`${BASE_URL}/manage/users/${userId}`));
  }

  getColumns() {
    return [{
      Header: 'Name',
      accessor: 'contactName',
      filterMethod: (filter, row) => {
        return row[filter.id] !== null ? row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) >= 0 : false;
      },
      Cell: row =>  {
       return (<span className="text-primary hand" onClick={(e) => this.selectUser(e, row.original.userId)}>{row.value}</span>);
      },
      maxWidth: 175,
    },
      {
        Header: 'Email',
        accessor: 'userName',
        filterMethod: (filter, row) => {
          return row[filter.id] !== null ? row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) >= 0 : false;
        },
      }
    , {
      id: 'roles',
      Header: 'Roles',
      accessor: x => join(x.roles.map(x => x.roleName), ', '),
      filterMethod: (filter, row) => {
        return row[filter.id] !== null ? row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) >= 0 : false;
      },
        maxWidth: 150,
    }, {
      id: 'lastLoginDate',
      Header: 'Last Login',
      accessor: x => moment(x.lastLoginDate).format(dateFormat),
      sortMethod: (a, b) => {
        return moment(a, dateFormat).isAfter(moment(b, dateFormat)) ? 1 : -1;
      },
        maxWidth: 100,
      Filter: ({filter, onChange}) => <span></span>,
    }, {
      id: 'createdDate',
      Header: 'Created',
      accessor: x => moment(x.createDate).format(dateFormat),
      sortMethod: (a, b) => {
        return moment(a, dateFormat).isAfter(moment(b, dateFormat)) ? 1 : -1;
      },
        maxWidth: 100,
      Filter: ({filter, onChange}) => <span></span>,
    }, {
      Header: 'Is Active',
      accessor: 'isActive',
      Cell: row => <div style={{textAlign: 'center', width: '100%'}}><i
        className={row.value ? 'fa fa-check text-success' : 'fa fa-times text-danger'}/></div>,
      maxWidth: 100,
      Filter: ({filter, onChange}) => <span></span>,
    }, {
      Header: 'Is Locked',
      accessor: 'isLockedOut',
      Cell: row => <div style={{textAlign: 'center', width: '100%'}}><i
        className={row.value ? 'fa fa-lock text-danger' : 'fa fa-unlock text-success'}/></div>,
      maxWidth: 100,
      Filter: ({filter, onChange}) => <span></span>,
    }, {
      Header: 'Auth Request',
      accessor: 'hasAuthorisationRequest',
      Cell: row => <div style={{textAlign: 'center', width: '100%'}}><i
        className={row.value ? 'fa fa-check text-danger' : 'fa fa-times text-success'}/></div>,
      maxWidth: 100,
      Filter: ({filter, onChange}) => <span></span>,
    },

    ];
  }

  handleRedirection = () => {
    const {account, dispatch} = this.props;
    const roles = mustBeArray(account && account.user && account.user.roles);
    if(_.find(roles, o => [ROLE_ClientUser, ROLE_LocationUser].includes(o))){
      return dispatch(push(`${BASE_URL}/`));
    }
    return dispatch(push(`${BASE_URL}/manage/users/`));
  }

  render() {
    return (<div>
      <Collapse isOpen={!this.props.children}>
        <div className="row">
          <div className="col-12">
            <h4 style={{marginBottom: '20px'}}>Manage Users&nbsp;<Button color="success" onClick={this.newUser}><i className="fa fa-plus"/> Add
              user</Button></h4>

            <ReactTable
              sortable={true}
              filterable={true}
              showPagination={true}
              data={this.props.users.items}
              columns={this.getColumns()}
              defaultPageSize={20}
              minRows={2}
              defaultSorted={[{id: 'hasAuthorisationRequest', desc: true}]}
            />

          </div>
        </div>
      </Collapse>

      <Outlet />
    </div>);
  }
}

UsersPage.propTypes = {

};

function mapStateToProps(state){
  return {
    users: state.users,
    roles: state.roles,
    apiConfig: state.apiConfig,
    account: state.account
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage);


